import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Loading } from 'src/components/common/loading/Loading';
import { useCurrentAccountId } from 'src/hooks/useCurrentAccountId';

import { SidebarLayout } from './components/templates';
import {
  cloudGraphOnboarding,
  cloudOnboardingRoutes,
  graphOnboarding,
  routerSetupRoutes,
} from './routes';

const EndpointSelectionPage = React.lazy(async () => ({
  default: (
    await import(
      /* webpackPrefetch: true, webpackChunkName: "EndpointSelectionPage" */ './views/endpointSelectionPage/EndpointSelectionPage'
    )
  ).EndpointSelectionPage,
}));

const SetupSubRoutes = React.lazy(async () => ({
  default: (
    await import(
      /* webpackPrefetch: true, webpackChunkName: "SetupSubRoutes" */ './views/setupSubRoutes/SetupSubRoutes'
    )
  ).SetupSubRoutes,
}));

export const GraphOnboardingRoutes = () => {
  const [accountId] = useCurrentAccountId();

  if (!accountId) return <Loading />;

  return (
    <SidebarLayout>
      <React.Suspense fallback={<Loading />}>
        <Switch>
          {/* Landing Page */}
          <Route
            path={graphOnboarding.definition}
            component={EndpointSelectionPage}
            exact
          />
          {/* Serverless/Cloud Onboarding Routes */}
          <Route path={cloudOnboardingRoutes}>
            <Switch>
              <Route
                path={cloudGraphOnboarding.definition}
                exact
                render={() => (
                  <Redirect
                    to={graphOnboarding.location({
                      orgId: accountId,
                    })}
                  />
                )}
              />
              <Route path={routerSetupRoutes} component={SetupSubRoutes} />
            </Switch>
          </Route>
        </Switch>
      </React.Suspense>
    </SidebarLayout>
  );
};
